import { createSlice } from "@reduxjs/toolkit";

const initialState = () => ({});

export const filterReducer = createSlice({
  name: "dtUpcomingFilter",
  initialState,
  reducers: {
    setDTUpcomingFilter: (state, action) => {
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
const { actions, reducer } = filterReducer;
export const { setDTUpcomingFilter } = actions;

export default reducer;
